import { JsonType } from '@intigral/types';

/**
 *
 * @param json JSON data in parsed object.
 * @param key The key to be accessed. To define multiple level, seperate key with . (dot).
 * @returns Value of JSON object for the key.
 */
export function getValueFromJson(json: any, key: string): string | null | object {
    const keyLevels: string[] = key.split('.');
    for (const index of keyLevels) {
        if (typeof json[index] !== 'undefined') {
            json = json[index];
        } else {
            return null;
        }
    }
    return json;
}

export const getPropFromJsonObject = (jsonObject: any, property: string) => {
    try {
        return jsonObject[property] || {};
    } catch (e) {
        return {};
    }
};

export const isValidJSON = (data: string): boolean => {
    try {
        const parsed = JSON.parse(data);
        return typeof parsed === 'object' && parsed !== null;
    } catch (e) {
        return false;
    }
};

export const parseStringToJSON = (data: string): JsonType => {
    return JSON.parse(data);
};

export const parseAnyToJSONString = (data: any): string => {
    return JSON.stringify(data);
};

export const convertObjectToArray = (obj: {
    [key: string]: string | number;
}): { name: string; value: string | number }[] => {
    return Object.entries(obj).map(([key, value]) => ({
        name: key,
        value: value,
    }));
};

/**
 * Format params with replacements
 * Example:
 * const params = {
 *     'test': '{test}',
 *     'test2': '{test2}',
 * };
 * const replacements = {
 *     'test': 'test',
 *     'test2': 'test2',
 * };
 *
 * @param params
 * @param replacements
 * @param regex
 * @returns {Record<string, string>}
 */
export const formatParams = (params: any, replacements: Record<string, string>, regex = /\{([^}]+)\}/g) => {
    const formattedParams = { ...params };

    for (const [key, value] of Object.entries(formattedParams)) {
        if (typeof value === 'string') {
            // Use regex to find all matches between curly braces
            const matches = value.match(regex);

            if (matches) {
                let formattedValue = value;
                matches.forEach((match) => {
                    // Extract the key without curly braces
                    const placeholder = match.slice(1, -1); // Remove { and }
                    if (replacements[placeholder]) {
                        formattedValue = formattedValue.replace(match, replacements[placeholder]);
                    }
                });
                formattedParams[key] = formattedValue;
            }
        }
    }

    return formattedParams;
};
